import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class AmazonService extends ApiService {
  entityType = EntityType.AMAZON;
  url = 'api/marketplace/amazon/search/';
}
